import css from "standard/css";

const style = css`
  .corrigida {
    border-radius: var(--border-radius-pill);
    color: var(--color-master-lightest);
    font-family: var(--font-family-base);
    font-size: var(--font-size-xxs);
    font-weight: var(--font-weight-medium);
    line-height: var(--line-height-sm);
    padding: var(--spacing_inset-quarck) var(--spacing_inset-xs);
    background-color: var(--color-success);
  }

  .pendente {
    border-radius: var(--border-radius-pill);
    color: var(--color-master-lightest);
    font-family: var(--font-family-base);
    font-size: var(--font-size-xxs);
    font-weight: var(--font-weight-medium);
    line-height: var(--line-height-sm);
    padding: var(--spacing_inset-quarck) var(--spacing_inset-xs);
    background-color: var(--color-danger);
  }
`;

export default style;
